"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportType = void 0;
var ReportType;
(function (ReportType) {
    ReportType["CURRENT"] = "current";
    ReportType["HOURLY"] = "hourly";
    ReportType["DAILY"] = "daily";
    ReportType["WEEKLY"] = "weekly";
    ReportType["MONTHLY"] = "monthly";
    ReportType["TOP"] = "top";
    ReportType["TOTAL"] = "total";
})(ReportType = exports.ReportType || (exports.ReportType = {}));
//# sourceMappingURL=types.js.map